export default "__VITE_ASSET__BpErHPQ9__"